export default {
  // User types grouped by category ex: laboratory, hospital
  GROUPED_USER_TYPES: [
    {
      label: "Laboratory",
      allow_to_add: [
        "LAB_ADMIN",
        "LAB_MANAGER",
        "LAB_TECHNOLOGIST",
        "LAB_SUPER_ADMIN",
      ],
      options: [
        {
          name: "Billing Representative",
          value: "BILLING_REPRESENTATIVE",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
        {
          name: "Lab Admin",
          value: "LAB_ADMIN",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
          ],
        },
      ],
    },
    {
      label: "Billing",
      allow_to_add: [
        "LAB_ADMIN",
        "LAB_MANAGER",
        "LAB_TECHNOLOGIST",
        "LAB_SUPER_ADMIN",
        "BILLING_REPRESENTATIVE",
        "LAB_SUPER_ADMIN",
      ],
      options: [
        {
          name: "AR-Lead",
          value: "AR_LEAD",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "AR-Excutive",
          value: "AR_EXECUTIVE",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "CP-Lead",
          value: "CP_LEAD",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "Coding-Lead",
          value: "CODING_LEAD",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "Coding-Excutive",
          value: "CODING_EXECUTIVE",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "Posting-Excutive",
          value: "POSTING_EXECUTIVE",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
        {
          name: "Senior-FTE",
          value: "SR_FTE",
          allow_to_add: [
            "LAB_ADMIN",
            "LAB_MANAGER",
            "LAB_TECHNOLOGIST",
            "LAB_SUPER_ADMIN",
            "BILLING_REPRESENTATIVE",

          ],
        },
      ],
    },
  ],


  // Lab User Types
  LAB_USER_TYPES: [
    {
      name: "Billing Representative",
      value: "BILLING_REPRESENTATIVE",
    },
    {
      name: "Lab Admin",
      value: "LAB_ADMIN",
    },
    {
      name: "Lab Manager",
      value: "LAB_MANAGER",
    },
    {
      name: "Lab Assistant",
      value: "LAB_DATA_ASSISTANT",
    },
    {
      name:"Lab Technologist",
      value:"LAB_TECHNOLOGIST"
    },
    {
      name: "Lab Super Admin",
      value: "LAB_SUPER_ADMIN",
    },
    {
      name: "Lab Data Admin",
      value: "LAB_DATA_ADMIN",
    },
    {
      name: "QC Manager",
      value: "QC_MANAGER",
    },
    { value: "CP_LEAD", name: "CP-Lead" },
    { value: "CODING_LEAD", name: "Coding-Lead" },
    { value: "CODING_EXECUTIVE", name: "Coding-Excutive" },
    { value: "POSTING_EXECUTIVE", name: "Posting-Excutive" },
    { value: "SR_FTE", name: "Senior-FTE" },
    {
      value: "AR_LEAD",
      name: "AR-Lead",
    },
    {
      value: "AR_EXECUTIVE",
      name: "AR-Excutive",
    },
  ],

  // Hospital User Types
  HOSPITAL_USER_TYPES: [
    {
      name: "Physician",
      value: "HOSPITAL_PHYSICIAN",
      allow_multiple: false,
      allow_to_add: ["HOSPITAL_ADMIN", "HOSPITAL_ACCOUNT_MANAGER"],
    },
    {
      name: "Hospital Admin",
      value: "HOSPITAL_ADMIN",
      allow_multiple: true,
      allow_to_add: [
        "LAB_ADMIN",
        "LAB_MANAGER",
        "LAB_SUPER_ADMIN",
      ],
    },
    {
      name: "Hospital Account Manager",
      value: "HOSPITAL_ACCOUNT_MANAGER",
      allow_multiple: true,
      allow_to_add: ["HOSPITAL_ADMIN", "HOSPITAL_ACCOUNT_MANAGER"],
    },
    {
      name: "Business Development Manager",
      value: "HOSPITAL_MARKETING_MANAGER",
      allow_multiple: true,
      allow_to_add: ["LAB_ADMIN", "LAB_MANAGER"],
    },
    {
      name: "Sales Director",
      value: "SALES_DIRECTOR",
      allow_multiple: true,
      allow_to_add: ["LAB_ADMIN", "LAB_MANAGER"],
    },
    {
      name: "Territory Manager",
      value: "MARKETER",
      allow_multiple: true,
      allow_to_add: [
        "LAB_ADMIN",
        "LAB_MANAGER",
        "LAB_SUPER_ADMIN",
      ],
    },
    {
      name: 'Account Manager',
      value: 'ACCOUNT_MANAGER',
      allow_multiple: true,
      allow_to_add: ["LAB_ADMIN", "LAB_MANAGER"],
    }
  ],

  //billing user types
  BILLING_USER_TYPES: [
    {
      value: "AR_LEAD",
      label: "AR-Lead",
    },
    {
      value: "AR_EXECUTIVE",
      label: "AR-Excutive",
    },
    {
      value: "BILLING_REPRESENTATIVE",
      label: "Billing Representative"
    },
    { value: "CP_LEAD", label: "CP-Lead" },
    { value: "CODING_LEAD", label: "Coding-Lead" },
    { value: "CODING_EXECUTIVE", label: "Coding-Excutive" },
    { value: "POSTING_EXECUTIVE", label: "Posting-Excutive" },
    { value: "SR_FTE", label: "Senior-FTE" },
  ],

  //Facility users
  FACILITY_USER_TYPES: [
    { value: "HOSPITAL_MARKETING_MANAGER", label: "Business Development Manager" },
    { value: "HOSPITAL_ADMIN", label: "Facility Admin" },
    { value: "HOSPITAL_ACCOUNT_MANAGER", label: "Facility Account Manager" },
    { value: "HOSPITAL_PHYSICIAN", label: "Physician" },
    { value: "SALES_DIRECTOR", label: "Sales Director" },
    { value: "MARKETER", label: "Territory Manager" },
  ],

  //User Type Map
  USER_TYPE_MAP: {
    LAB_ADMIN: "Lab Admin",
    ADMIN: "Admin",
    LAB_MANAGER: "Lab Manager",
    HOSPITAL_PHYSICIAN: "Physician",
    HOSPITAL_ADMIN: "Facility Admin",
    HOSPITAL_ACCOUNT_MANAGER: "Facility Account Manager",
    BILLING_REPRESENTATIVE: "Billing Representative",
    LAB_DATA_ASSISTANT: "Lab Assistant",
    LAB_TECHNOLOGIST: "Lab Technologist",
    LAB_SUPER_ADMIN: "Lab Super Admin",
    TOP_DOG: "Top Dog",
    MARKETER: "Territory Manager",
    TOP_DOG: "Top Dog",
    LAB_SUPER_ADMIN: "Lab Super Admin",
    HOSPITAL_MARKETING_MANAGER: "Business Development Manager",
    SALES_DIRECTOR: "Sales Director",
    LAB_DATA_ADMIN: "Lab Data Admin",
    QC_MANAGER: "QC Manager",
    AR_LEAD: "AR-Lead",
    AR_EXECUTIVE: "AR-Excutive",
    CP_LEAD: "CP-Lead",
    CODING_LEAD: "Coding-Lead",
    CODING_EXECUTIVE: "Coding-Excutive",
    POSTING_EXECUTIVE: "Posting-Excutive",
    SR_FTE: "Senior-FTE",
    ACCOUNT_MANAGER: 'Account Manager'

  },

  userTypeMap: {
    LAB_ADMIN: "Admin",
    ADMIN: "Admin",
    LAB_MANAGER: "Lab Manager",
    HOSPITAL_PHYSICIAN: "Physician",
    HOSPITAL_ADMIN: "Ordering Facility Admin",
    HOSPITAL_ACCOUNT_MANAGER: "Facility Account Manager",
    BILLING_REPRESENTATIVE: "Billing Representative",
    LAB_DATA_ASSISTANT: "Lab Assistant",
    LAB_TECHNOLOGIST: "Lab Technologist",
    MARKETER: "Territory Manager",
    LAB_SUPER_ADMIN: "Lab Super Admin",
    HOSPITAL_MARKETING_MANAGER: "Business Development Manager",
    SALES_DIRECTOR: "Sales Director",
    LAB_DATA_ADMIN: "Lab Data Admin",
    QC_MANAGER: "QC Manager",
    AR_LEAD: "AR-Lead",
    AR_EXECUTIVE: "AR-Excutive",
    CP_LEAD: "CP-Lead",
    CODING_LEAD: "Coding-Lead",
    CODING_EXECUTIVE: "Coding-Excutive",
    POSTING_EXECUTIVE: "Posting-Excutive",
    SR_FTE: "Senior-FTE",
    ACCOUNT_MANAGER: 'Account Manager',
    LAB_PHYSICIAN:"Lab Physician",
    DEVELOPER_BOT:"Developer Bot"
  },
}
